// extracted by mini-css-extract-plugin
module.exports = {"container":"supplier-carousel_container__e2Ab0","inner":"supplier-carousel_inner__mg9BG","peach":"supplier-carousel_peach__lrnZ1","dark":"supplier-carousel_dark__L7M0e"};